/* Zurevan Retro · JS (vanilla, sin librerías). Una función por componente. */
(function () {
  'use strict';

  if (window.__rgBooted) return;
  window.__rgBooted = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Aparición al hacer scroll (observer compartido) ---- */
  function initReveal() {
    var els = document.querySelectorAll('.rg-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rg-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rg-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) {
      if (!el.style.getPropertyValue('--rg-delay')) {
        var group = el.closest('[data-rg-stagger]');
        if (group) {
          var sibs = Array.prototype.slice.call(group.querySelectorAll('.rg-reveal'));
          el.style.setProperty('--rg-delay', (sibs.indexOf(el) * 0.08) + 's');
        }
      }
      io.observe(el);
    });
  }

  /* ---- Parallax suave (solo transform) ---- */
  function initParallax() {
    var layers = document.querySelectorAll('[data-rg-parallax]');
    if (!layers.length || reduce) return;
    var ticking = false;
    function update() {
      layers.forEach(function (layer) {
        var host = layer.closest('section') || layer.parentElement;
        var rect = host.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        var amount = parseFloat(layer.getAttribute('data-rg-parallax')) || 20;
        layer.style.transform = 'scale(1.04) translateY(' + (progress * amount).toFixed(2) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---- Galería de producto ---- */
  function initGaleria() {
    document.querySelectorAll('[data-rg-galeria]').forEach(function (g) {
      var main = g.querySelector('[data-rg-principal] img');
      var thumbs = g.querySelectorAll('.rg-comprar__mini');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var full = t.getAttribute('data-full');
          if (full) { main.src = full; main.alt = t.getAttribute('data-alt') || ''; }
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }

  /* ---- Ofertas (1 consola / pack doble): actualiza precio y botón ---- */
  function initOfertas() {
    document.querySelectorAll('[data-rg-compra]').forEach(function (box) {
      var radios = box.querySelectorAll('input[data-rg-oferta]');
      if (!radios.length) return;
      var precio = box.querySelector('[data-rg-precio]');
      var antes = box.querySelector('[data-rg-antes]');
      var ahorro = box.querySelector('[data-rg-ahorro]');
      var boton = box.querySelector('[data-rg-anadir]');

      function actualizar() {
        var sel = box.querySelector('input[data-rg-oferta]:checked');
        if (!sel) return;
        if (precio) precio.textContent = sel.getAttribute('data-precio') || '';
        var ant = sel.getAttribute('data-antes');
        if (antes) { antes.textContent = ant || ''; antes.style.display = ant ? '' : 'none'; }
        var ah = sel.getAttribute('data-ahorro');
        if (ahorro) { ahorro.textContent = ah ? ('Ahorras ' + ah) : ''; ahorro.style.display = ah ? '' : 'none'; }
        if (boton) {
          var libre = sel.getAttribute('data-disponible') !== 'false';
          if (libre) {
            boton.removeAttribute('disabled');
            boton.textContent = (boton.getAttribute('data-texto') || 'Añadir a la cesta') + ' · ' + (sel.getAttribute('data-precio') || '');
          } else {
            boton.setAttribute('disabled', 'disabled');
            boton.textContent = boton.getAttribute('data-agotado') || 'Agotado';
          }
        }
      }
      radios.forEach(function (r) { r.addEventListener('change', actualizar); });
      actualizar();
    });
  }

  function arrancar() {
    initReveal();
    initParallax();
    initGaleria();
    initOfertas();

    /* Red de seguridad: si el observer no dispara, nada se queda invisible. */
    requestAnimationFrame(function () {
      document.querySelectorAll('.rg-reveal:not(.rg-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < (window.innerHeight || 800) && r.bottom > 0) el.classList.add('rg-visible');
      });
    });
    setTimeout(function () {
      document.querySelectorAll('.rg-reveal:not(.rg-visible)').forEach(function (el) { el.classList.add('rg-visible'); });
    }, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
